<template>
  <div class="cityAnalysis">
    <div class="management-search">
      <div class="management-search-1">
        渠道：
        <a-select
          v-model="channelList"
          placeholder="请选择渠道"
          class="select-tag"
          allowClear
          mode="multiple"
        >
          <a-select-option
            v-for="(item, index) in channelSelectList"
            :key="item.id"
            :value="item.name"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        平台：
        <a-select
          v-model="platformIdList"
          placeholder="请选择平台"
          class="select-tag"
          allowClear
          mode="multiple"
        >
          <a-select-option
            v-for="(item, index) in platformSelectList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        创建日期：
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="startDate"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          format="YYYY-MM-DD"
          placeholder="结束时间"
          v-model="endDate"
        />
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="ExportData">导出</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="false"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.city"
      @change="changeSort"
    >
      <span slot="uvRegisterCount" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ record.uvCount }},通过:{{ text }}
          </template>
          {{ text }}/{{ record.uvCount }}
        </a-tooltip>
      </span>
      <span slot="preCheck" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ text }},通过:{{ record.preCheckSuccessCount }}
          </template>
          {{ record.preCheckSuccessCount }}/{{ text }}
        </a-tooltip>
        &nbsp;&nbsp;
        <a-tooltip
          placement="topLeft"
          v-if="preCheckFailReasonMapShow(record.preCheckFailReasonMap)"
        >
          <template slot="title">
            <template v-for="(value, key) in record.preCheckFailReasonMap">
              <span>{{ key }}:{{ value }}</span
              ><br />
            </template>
          </template>
          <a-icon type="info-circle" />
        </a-tooltip>
      </span>
      <span slot="platformDump" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ text }},通过:{{ record.platformDumpSuccessCount }}
          </template>
          {{ record.platformDumpSuccessCount }}/{{ text }}
        </a-tooltip>
      </span>
      <span slot="platformCheckSuccess" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ record.platformCompleteCount }},通过:{{ text }}
          </template>
          {{ text }}/{{ record.platformCompleteCount }}
        </a-tooltip>
      </span>
      <span slot="platformComplete" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ record.platformCheckCount }},通过:{{ text }}
          </template>
          {{ text }}/{{ record.platformCheckCount }}
        </a-tooltip>
      </span>
      <span slot="platformShow" slot-scope="text, record">
        <a-tooltip placement="topLeft">
          <template slot="title">
            总提交数:{{ record.platformCompleteCount }},通过:{{ text }}
          </template>
          {{ text }}/{{ record.platformCompleteCount }}
        </a-tooltip>
      </span>
    </a-table>
  </div>
</template>
<script>
import api from "../lib/cityAnalysis.js";
import stateStatisticsApi from "../lib/stateStatistics.js";
import moment from "moment";

export default {
  name: "cityAnalysis",
  data() {
    return {
      platformParamId: undefined,
      pageNo: 1,
      tableColumns: [
        {
          title: "城市",
          dataIndex: "city",
          align: "center",
        },
        {
          title: "uv注册",
          dataIndex: "uvRegisterCount",
          scopedSlots: { customRender: "uvRegisterCount" },
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.uvRegisterSuccessRate,
              b.uvRegisterSuccessRate
            );
          },
        },
        {
          title: "uv注册成功率",
          dataIndex: "uvRegisterSuccessRate",
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.uvRegisterSuccessRate,
              b.uvRegisterSuccessRate
            );
          },
          customRender: (text, row, index) => {
            if (text == 0 && row.uvCount == 0) {
              return {
                children: <span>—</span>,
              };
            } else if (text == 0 && row.uvRegisterCount == 0) {
              return {
                children: <span>0</span>,
              };
            }
            return <span>{(text * 100).toFixed(2) + "%"}</span>;
          },
        },
        {
          title: "前置筛查",
          dataIndex: "preCheckCount",
          scopedSlots: { customRender: "preCheck" },
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.preCheckSuccessRate,
              b.preCheckSuccessRate
            );
          },
        },
        {
          title: "前置筛查成功率",
          dataIndex: "preCheckSuccessRate",
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.preCheckSuccessRate,
              b.preCheckSuccessRate
            );
          },
          customRender: (text, row, index) => {
            if (text == 0 && row.preCheckCount == 0) {
              return {
                children: <span>—</span>,
              };
            } else if (text == 0 && row.preCheckSuccessCount == 0) {
              return {
                children: <span>0</span>,
              };
            }
            return <span>{(text * 100).toFixed(2) + "%"}</span>;
          },
        },
        {
          title: "撞库",
          dataIndex: "platformDumpCount",
          scopedSlots: { customRender: "platformDump" },
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.platformDumpSuccessRate,
              b.platformDumpSuccessRate
            );
          },
        },
        {
          title: "撞库成功率",
          dataIndex: "platformDumpSuccessRate",
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.platformDumpSuccessRate,
              b.platformDumpSuccessRate
            );
          },
          customRender: (text, row, index) => {
            if (text == 0 && row.platformDumpCount == 0) {
              return {
                children: <span>—</span>,
              };
            } else if (text == 0 && row.platformDumpSuccessCount == 0) {
              return {
                children: <span>0</span>,
              };
            }
            return <span>{(text * 100).toFixed(2) + "%"}</span>;
          },
        },
        {
          title: "平台进件",
          dataIndex: "platformCompleteCount",
          scopedSlots: { customRender: "platformComplete" },
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.platformCompleteRate,
              b.platformCompleteRate
            );
          },
        },
        {
          title: "平台展示",
          dataIndex: "platformShowCount",
          scopedSlots: { customRender: "platformShow" },
          sorter: (a, b) => {
            return this.sorter(a, b, a.platformShowRate, b.platformShowRate);
          },
        },
        {
          title: "平台成单",
          dataIndex: "platformCheckSuccessCount",
          scopedSlots: { customRender: "platformCheckSuccess" },
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.platformCheckSuccessRate,
              b.platformCheckSuccessRate
            );
          },
        },
        {
          title: "平台成单成功率",
          dataIndex: "platformCheckSuccessRate",
          sorter: (a, b) => {
            return this.sorter(
              a,
              b,
              a.platformCheckSuccessRate,
              b.platformCheckSuccessRate
            );
          },
          customRender: (text, row, index) => {
            if (text == 0 && row.platformCompleteCount == 0) {
              return {
                children: <span>—</span>,
              };
            } else if (text == 0 && row.platformCheckSuccessCount == 0) {
              return {
                children: <span>0</span>,
              };
            }
            return <span>{(text * 100).toFixed(2) + "%"}</span>;
          },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      startDate: null,
      endDate: null,
      channelList: [],
      channelSelectList: [],
      platformIdList: [],
      platformSelectList: [],
      sortOrder: null,
    };
  },
  computed: {
    preCheckFailReasonMapShow: () => {
      return (preCheckFailReasonMap) => {
        if (preCheckFailReasonMap) {
          if (JSON.stringify(preCheckFailReasonMap) == "{}") {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      };
    },
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endDate) {
        return this.$common.dayFormat(this.endDate) + " " + "23:59:59";
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startDate) {
        return this.$common.dayFormat(this.startDate) + " " + "00:00:00";
      }
      return "";
    },
  },
  created() {
    this.today();
    this.query(1);
    this.getPlatformSelectList();
    this.getChannelList();
  },
  methods: {
    ExportData() {
      location.href =
        process.env.VUE_APP_CURRENTMODE == "dev"
          ? process.env.VUE_APP_BASE_API
          : location.origin +
            `/api/manager/analysis/exportCityAnalysis?channelList=${this.channelList}&platformIdList=${this.platformIdList}&gmtCreatedStart=${this.lastLoginDateStartTime}&gmtCreatedEnd=${this.lastLoginDateEndTime}`;
    },
    sorter(a, b, aText, bText) {
      let result = aText - bText;
      if (this.sortOrder === "ascend") {
        if (a.sorter || b.sorter) {
          result = 99999999;
        }
      } else if (this.sortOrder === "descend") {
        if (a.sorter || b.sorter) {
          result = -99999999;
        }
      }
      return result;
    },
    changeSort(pagination, filters, sorter) {
      this.sortOrder = sorter.order;
    },
    today() {
      let startTime = new Date();
      let endTime = new Date();
      this.startDate = moment(startTime, "YYYY-MM-DD");
      this.endDate = moment(endTime, "YYYY-MM-DD");
    },
    getChannelList(channel) {
      api.channelList({ channel }).then((res) => {
        if (res.result == 200) {
          this.channelSelectList.splice(0);
          res.data.forEach((element, index) => {
            this.channelSelectList.push({ id: index + 1, name: element });
          });
        }
      });
    },
    getPlatformSelectList() {
      stateStatisticsApi.platformSelectList().then((res) => {
        if (res.result == 200) {
          this.platformSelectList = res.data;
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        channelList: this.channelList,
        platformIdList: this.platformIdList,
        gmtCreatedStart: this.lastLoginDateStartTime,
        gmtCreatedEnd: this.lastLoginDateEndTime,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data;
            this.tableDataSource = list;
            let preCheckCount = 0,
              platformDumpCount = 0,
              platformCompleteCount = 0,
              preCheckSuccessCount = 0,
              platformDumpSuccessCount = 0,
              platformCheckSuccessCount = 0,
              platformCheckFailCount = 0,
              platformShowCount = 0,
              platformCheckCount = 0,
              uvCount = 0,
              uvRegisterCount = 0;
            this.tableDataSource.forEach((element) => {
              this.$set(
                element,
                "preCheckCount",
                element.preCheckSuccessCount + element.preCheckFailCount
              );
              this.$set(
                element,
                "preCheckSuccessRate",
                element.preCheckCount == 0
                  ? 0
                  : element.preCheckSuccessCount / element.preCheckCount
              );
              this.$set(
                element,
                "platformCheckCount",
                element.platformCheckSuccessCount +
                  element.platformCheckFailCount
              );
              this.$set(
                element,
                "platformDumpCount",
                element.platformDumpSuccessCount + element.platformDumpFailCount
              );
              this.$set(
                element,
                "platformDumpSuccessRate",
                element.platformDumpCount == 0
                  ? 0
                  : element.platformDumpSuccessCount / element.platformDumpCount
              );
              this.$set(
                element,
                "platformCheckSuccessRate",
                element.platformCompleteCount == 0
                  ? 0
                  : element.platformCheckSuccessCount /
                      element.platformCompleteCount
              );
              this.$set(
                element,
                "uvRegisterSuccessRate",
                element.uvCount == 0
                  ? 0
                  : element.uvRegisterCount / element.uvCount
              );
              this.$set(
                element,
                "platformCompleteRate",
                element.platformCheckCount == 0
                  ? 0
                  : element.platformCompleteCount / element.platformCheckCount
              );
              this.$set(
                element,
                "platformShowRate",
                element.platformCompleteCount == 0
                  ? 0
                  : element.platformShowCount / element.platformCompleteCount
              );
              this.$set(element, "sorter", false);
              preCheckCount += element.preCheckCount;
              platformDumpCount += element.platformDumpCount;
              platformCompleteCount += element.platformCompleteCount;
              preCheckSuccessCount += element.preCheckSuccessCount;
              platformDumpSuccessCount += element.platformDumpSuccessCount;
              platformCheckSuccessCount += element.platformCheckSuccessCount;
              platformCheckFailCount += element.platformCheckFailCount;
              platformCheckCount += element.platformCheckCount;
              uvCount += element.uvCount;
              uvRegisterCount += element.uvRegisterCount;
              platformShowCount += element.platformShowCount;
            });
            this.tableDataSource.push({
              preCheckCount,
              platformDumpCount,
              platformCompleteCount,
              preCheckSuccessCount,
              platformDumpSuccessCount,
              platformCheckSuccessCount,
              platformCheckFailCount,
              platformCheckCount,
              platformShowCount,
              preCheckFailReasonMap: null,
              platformShowRate:
                platformCompleteCount == 0
                  ? 0
                  : platformShowCount / platformCompleteCount,
              platformCompleteRate:
                platformCheckCount == 0
                  ? 0
                  : platformCompleteCount / platformCheckCount,
              preCheckSuccessRate:
                preCheckCount == 0 ? 0 : preCheckSuccessCount / preCheckCount,
              platformDumpSuccessRate:
                platformDumpCount == 0
                  ? 0
                  : platformDumpSuccessCount / platformDumpCount,
              platformCheckSuccessRate:
                platformCompleteCount == 0
                  ? 0
                  : platformCheckSuccessCount / platformCompleteCount,
              uvCount,
              uvRegisterCount,
              uvRegisterSuccessRate:
                uvCount == 0 ? 0 : uvRegisterCount / uvCount,
              city: "合计",
              sorter: true,
            });
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cityAnalysis {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
